import ClassNames from "classnames";
import * as React from "react";
import Styles from "./Breadcrumbs.module.css";

import BreadcrumbItem from "./BreadcrumbsItem";
import BreadcrumbSeparator from "./BreadcrumbsSeparator";

export interface Props {
  children: React.ReactNode[];
  className?: string;
  separator?: string; // or svg?
}

const toBreadcrumbItem = (child: React.ReactNode, index: number) => (
  <BreadcrumbItem key={`breadcrumb-item${index}`}>{child}</BreadcrumbItem>
);

const withSeparator = (lastIndex: number, separator: string) => (
  acc: any,
  child: React.ReactNode,
  index: number
) => {
  const notLast = index < lastIndex;
  if (notLast) {
    acc.push([
      child,
      <BreadcrumbSeparator key={`breadcrumb-sep${index}`}>
        {separator}
      </BreadcrumbSeparator>
    ]);
  } else {
    acc.push(child);
  }
  return acc;
};

const Breadcrumbs: React.FC<Props> = props => {
  const { children, className, separator = ">" } = props;

  const totalItems: number = children.length;
  const lastIndex: number = totalItems - 1;

  const links: React.ReactNode[] = children
    .map(toBreadcrumbItem)
    .reduce(withSeparator(lastIndex, separator), []);

  return (
    <ol
      className={ClassNames({
        [Styles.breadcrumbs]: true,
        [className]: className
      })}
    >
      {links}
    </ol>
  );
};

export default Breadcrumbs;
